module.exports = __webpack_public_path__ + "img/close-card.e8ab2ff8.svg";